import { z } from 'zod/v3';

const systemMessageSchema = z.object({
  id: z.string().optional(),
  role: z.literal('system'),
  content: z.string(),
});

const assistantMessageSchema = z.object({
  id: z.string().optional(),
  role: z.literal('assistant'),
  content: z.string(),
  parts: z
    .array(
      z.object({
        type: z.string(),
        toolInvocation: z
          .object({
            toolCallId: z.string(),
            state: z.string(),
            result: z.any(),
            toolName: z.string(),
            args: z.any(),
          })
          .optional(),
      })
    )
    .optional(),
});

const userMessageSchema = z.object({
  id: z.string().optional(),
  role: z.literal('user'),
  content: z.string(),
});

const imageMessageSchema = z.object({
  id: z.string().optional(),
  role: z.literal('image'),
  images: z.array(
    z.object({
      url: z.string(),
    })
  ),
});

const fileMessageSchema = z.object({
  id: z.string().optional(),
  role: z.literal('file'),
  data: z.string(),
  filename: z.string().optional().nullable(),
});

export type SystemMessage = z.infer<typeof systemMessageSchema>;
export type AssistantMessage = z.infer<typeof assistantMessageSchema>;
export type UserMessage = z.infer<typeof userMessageSchema>;
export type ImageMessage = z.infer<typeof imageMessageSchema>;
export type FileMessage = z.infer<typeof fileMessageSchema>;

export const llmMessageSchema = z.discriminatedUnion('role', [
  systemMessageSchema,
  assistantMessageSchema,
  userMessageSchema,
  imageMessageSchema,
  fileMessageSchema,
]);

export type Message = z.infer<typeof llmMessageSchema>;

export const systemMessage = (content: string): SystemMessage => ({
  role: 'system' as const,
  content,
});

export const assistantMessage = (content: string): AssistantMessage => ({
  role: 'assistant' as const,
  content,
});

export const userMessage = (content: string): UserMessage => ({
  role: 'user' as const,
  content,
});
